SupportContactChannelClickTemplate = require '../../../../contact_channel_click.html.mustache'
HelpWizardController = require "../../../helpWizardController"
Backbone = require 'backbone'
Backbone.$ = $

class EmailFormLiveChatClickView extends Backbone.View
  className: 'contact-channel-click-container'

  events :
    'click #ChatSuccess' : "chatsuccess"
    'click #otherContactChannel' : "chooseDifferentContactChannel"


  initialize: ->
    @I18nScope = 'modules.support'
    @template = SupportContactChannelClickTemplate

  render: ->
    @$el.html toHtml(@template, @toHash(), @I18nScope)

  toHash: ->
    hash =
      isChatClicked: true
    hash

  chatsuccess: () ->
    Backbone.history.navigate('#chat-success', {trigger: true})

  chooseDifferentContactChannel: () ->
    HelpWizardController.stepThree()

module.exports = EmailFormLiveChatClickView
